import 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import mapboxgl from 'mapbox-gl';

$(() => {

// Fade in body
    function fadeInBody(){
        $('#main').addClass('fade-in-body')
    }

    $(document).ready(function() {
        setTimeout(function () {
            fadeInBody()
        }, 200);
    })

// Tab index skip
    $('.skip-nav').on('click', function (e) {
        e.preventDefault();
        $('#main').focus();
    })

    $( "form.woocommerce-checkout :input" ).each( function( index, elem ) {

        var eId = $( elem ).attr( "id" );
        var label = null;

        if(
            eId && (
                label = $( elem )
                    .parents( "form" )
                    .find( "label[for=" + eId + "]" )
            ).length == 1
        ) {
            $( elem ).attr( "placeholder", $( label ).text() );
            $( label ).remove();
        }

    } );

// Header sticky nav
    function headerStickyNav(){
        let timer
        const banner = $('.banner')

        if ( banner.length ) {
            $(window).scroll(function(){
                if (timer) clearTimeout(timer)

                timer = setTimeout(function(){
                    headerStickyNavScroll()
                }, 10)
            })
        }
    }

    function reloadMasonryTabs(){
        const navPills = $('.nav-pills')

        $('.grid').masonry({
          // options
          percentPosition: true,
        });

        $('.grid').masonry('layout');

        jQuery.noConflict();

        if ( navPills.length ) {
            $('.nav-pills a').click(function(e) {
                $('.grid').masonry('layout');
            })
        }

        $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
            // Reload the already created masonry grid, each time you click the Bootstrap tab
            $('.grid').masonry('layout');
        });
    }

    if( $('.btn--next-section').length ){

        $('.btn--next-section').click(function(e) {

            var nextSection = $(this).parent().next();

            $('html, body').animate({
                scrollTop: $(nextSection).offset().top + 50
            });
        })
    }

    if( $('.artists-single__gallery').length ){
        let imageSlider = new Swiper('.artists-single__gallery .swiper-container', {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            centeredSlides: true,
            centeredSlidesBounds: true,
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    if( $('.event-image-carousel').length ){
        let imageSlider = new Swiper('.event-image-carousel .swiper-container', {
            spaceBetween: 30,
            slidesPerView: 1,
            loop: true,
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                },
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.event-image-carousel-wrap .swiper-button-next',
                prevEl: '.event-image-carousel-wrap .swiper-button-prev',
            },
        });
    }

    if( $('.testimonials').length ){
        let testimonialSlider = new Swiper('.testimonials .swiper-container', {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
        });
    }

    if( $('.reminders-list').length ){
        let remindersList = new Swiper('.reminders-list', {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
            },
        });
    }

    if( $('.gallery').length ){
        let imageSlider = new Swiper('.gallery .swiper-container', {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            lazy: {
                loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
                loadPrevNextAmount: 2 //or, if you wish, preload the next 2 images
              },
        });
    }

    if( $('.video-block__play-toggle').length ){

        $('.video-block__play-toggle').on('click',function(e) {
            e.preventDefault()
            let video = $('#banner-video')[0];

            $('.video-block__container').addClass('video-block__container--hide');
            if(!$(this).hasClass('video-block__play-toggle--embed')) {
                if ( video.paused ) {
                    video.play();
                    $('.video-block').addClass('video-block--active')
                } else {
                    video.pause();
                    $('.video-block').removeClass('video-block--active')
                }
            } else {
                var iframe = $(this).parent().parent().find('.video-embed iframe')
                if(iframe.length > 0) {
                    // Get the src attribute value
                    //console.log($('#video-embed'))
                    var src = $('#video-embed iframe').attr('src');

                    // Add autoplay=1 parameter to the src URL
                    src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';

                    // Set the modified src back to the iframe
                    $('#video-embed iframe').attr('src', src);
                }
            }


            return false;
        })

        // Onended function add icon back on
        if($('#banner-video')[0]) {
            $('#banner-video')[0].onended = function(e) {
                $('.video-block__container').removeClass('video-block__container--hide')
                $('.video-block').removeClass('video-block--active')
            }
        }
    }

    function headerStickyNavScroll(){
        let scrollAmount = $(window).scrollTop()

        if ( scrollAmount >= 2 ){
            $('body').addClass('sticky-active')
        } else {
            $('body').removeClass('sticky-active')
        }
    }

    headerStickyNavScroll();
    headerStickyNav()
    reloadMasonryTabs()

});

// Offcanvas Slideout
    function slideOutToggle(){
        $('.btn--open-contact').on('click',function(e) {
            e.preventDefault()

            if ($('body').hasClass('slideout-active') ){
                slideOutDeactivate()
            } else {
                slideOutActivate()
            }
        })

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                slideOutDeactivate()
            }
        });
    }

    function slideOutActivate(){
        $('body').addClass('slideout-active')
    }

    function slideOutDeactivate(){
        $('body').removeClass('slideout-active')

        setTimeout(function () {
            $('.burger-toggle').removeClass('burger-toggle--active')
        }, 200)
    }

// Offcanvas
    function navToggle(){
        $('.burger-toggle').on('click',function(e) {
            e.preventDefault()

            if( $('.burger-toggle').hasClass('burger-toggle--active') ) {
                navDeactivate()
            } else {
                navActivate()
            }

            if( $('body').hasClass('slideout-active') ) {
                slideOutDeactivate()
            } else {

            }
        })

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                navDeactivate()
            }
        });
    }

    function preventScroll(e) {
        e.preventDefault();
        e.stopPropagation();

        return false;
    }

    function navActivate(){
        document.querySelector('#app').addEventListener('wheel', preventScroll);

        setTimeout(function () {
            $('.burger-toggle').addClass('burger-toggle--active')
        }, 300)

        $('body').addClass('offcanvas-active')
    }

    function navDeactivate(){
        document.querySelector('#app').removeEventListener('wheel', preventScroll);

        $('body').removeClass('offcanvas-active')

        setTimeout(function () {
            $('.burger-toggle').removeClass('burger-toggle--active')
        }, 200)
    }

    $('.offcanvas-menu .offcanvas-menu__mobile .menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.menu-item-has-children').toggleClass('sub-menu-active');
    });

    navToggle()
    slideOutToggle()

    if( $('#map').length ){
        mapboxgl.accessToken = 'pk.eyJ1IjoiZGVzaWdud2VsbG5lc3N1ayIsImEiOiJjbGQ3ZzJmNnkwYnEwM3FxeGF1eGN0Z2oxIn0.IvryXzz5AmkA9ulq12_MGw';
        const map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [-2.248640, 53.465640],
            zoom: 13,
        });

        map.scrollZoom.disable();
        map.addControl(new mapboxgl.NavigationControl());

        const geojson = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [-2.248640, 53.465640]
              },
              properties: {
                title: 'Mapbox',
                description: 'Venture Arts'
              }
            },
          ]
        };

        // add markers to map
        for (const feature of geojson.features) {
          // create a HTML element for each feature
          const el = document.createElement('div');
          el.className = 'marker';

          // make a marker for each feature and add to the map
          new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(map);
        }
    }

// Stop all sound clips
    function stopAllSound(){
        $('.audio-clip').each(function () {
            $(this).find('audio')[0].pause()
            $(this).removeData('clicked');
        });
    }

    function pauseSound() {
        $('.audio-clip').each(function () {
            $(this).find('audio')[0].pause()
        });
    }

// Click to play/pause audio clips
    $('.audio-clip').on('click', function () {
        $('.audio-clip').removeClass('audio-clip--active');

        if ( $(this).data('clicked') ) {
            stopAllSound()
        } else {
            pauseSound();
            $(this).data('clicked', true);
            $(this).find('audio')[0].play();
            $(this).addClass('audio-clip--active');

            $(this).find('audio')[0].onended = function () {
                $('.audio-clip').removeClass('audio-clip--active');
            };
        }
    });

// Click to toggle more/less content
    $('.toggle-more').on('click', function (e) {
        e.preventDefault();
        $('.events-list').toggleClass('events-list--less'); 

        if( $('.events-list').hasClass('events-list--less') ){
            $(this).find('.btn__inner').text('See more')
        } else {
            $(this).find('.btn__inner').text('See less')
        }
    
    });
